/* eslint-disable */
var $ = window.jQuery = require('jquery');

import draggable from "vuedraggable";
import { mapGetters } from 'vuex';
import toast from '@/services/toast';

export default {
  name: 'unit-q-ans-list',
  components: {
    draggable
  },
  props: [],
  data() {
    return {
      quizListDetails:null,
      removeQuizId:'',
    }
  },
  computed: {
    dragOptions() {
      return {
        animation: 0,
        group: "description",
        ghostClass: "ghost"
      };
    },
  },
  mounted() {
    this.getIvQuizUnitsMethod()
  },
  methods: {
    getIvQuizUnitsMethod(){
      this.$store.dispatch('getIvQuizUniInfoAction').then((res) => {
        this.quizListDetails = res.data.data
      })
    },
    removeQuizagain(id) {
      $('#removQuizModalAgain').modal();
      this.removeQuizId = id
    },
    RemoveQuizConfirmationagain(){
      this.$store.dispatch('deleteIvQuizUniInfoAction', {
        id: this.removeQuizId
      }).then((res) => {
        this.getIvQuizUnitsMethod()
      }).catch((err) => {})
    }
  },
}